// extracted by mini-css-extract-plugin
export default {"input":"WidgetEmail_input__IsSr8"};